// import i18n from '@/language/i18n'
import auth from '@/middleware/auth';

export default [
	{
		path: '/dashboard',
		name: 'Dashboard',
		icon: 'dashboard',
		meta: {
			title: 'menu.dashboard'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Dashboard')
		// children: [
		// 	{
		// 		path: 'aftersales',
		// 		name: 'aftersales',
		// 		icon: false,
		// 		hideLink: true,
		// 		meta: {
		// 			title: 'menu.main_commercial'
		// 		},
		// 		children: [
		// 			{
		// 				path: '/aftersales/main-commercial/kpis',
		// 				name: 'aftersales-kpis',
		// 				icon: false,
		// 				meta: {
		// 					title: 'menu.kpis'
		// 				},
		// 				beforeEnter: auth,
		// 				component: () => import('@/pages/aftersales/KPIs')
		// 			},
		// 			{
		// 				path: '/aftersales/main-commercial/staff-meeting',
		// 				name: 'aftersales-main-staff',
		// 				icon: false,
		// 				meta: {
		// 					title: 'menu.staff_meeting'
		// 				},
		// 				beforeEnter: auth,
		// 				component: () => import('@/pages/aftersales/StaffMeeting')
		// 			}
		// 		]
		// 	},
		// 	{
		// 		path: 'technical-services',
		// 		name: 'technical-services',
		// 		meta: {
		// 			title: 'menu.technical_services'
		// 		},
		// 		hideLink: true,
		// 		children: [
		// 			{
		// 				path: '/aftersales/technical-services/overview',
		// 				name: 'aftersales-technical-overview',
		// 				icon: false,
		// 				meta: {
		// 					title: 'menu.overview'
		// 				},
		// 				beforeEnter: auth,
		// 				component: () => import('@/pages/aftersales/Overview')
		// 			},
		// 			{
		// 				path: '/aftersales/technical-services/payments',
		// 				name: 'aftersales-technical-payments',
		// 				icon: false,
		// 				meta: {
		// 					title: 'menu.payments'
		// 				},
		// 				beforeEnter: auth,
		// 				component: () => import('@/pages/aftersales/Payments')
		// 			}
		// 		]
		// 	}
		// ]
	},
	{
		path: '/drumbeat/:page?/:id?',
		name: 'Drumbeat',
		icon: 'drumbeat',
		meta: {
			title: 'menu.drumbeat'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Drumbeat')
	},
	{
		path: '/users/:page?/:id?',
		name: 'Users',
		icon: 'users',
		meta: {
			title: 'menu.users'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Users')
	},
	{
		path: '/roles/:page?/:id?',
		name: 'Roles',
		icon: 'roles',
		meta: {
			title: 'menu.roles'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Roles')
	},
	{
		path: '/notifications',
		name: 'Notifications',
		icon: 'bell',
		meta: {
			title: 'labels.notification'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Notifications')
	},
	{
		path: '/countries/:page?/:id?',
		name: 'Countries',
		icon: 'country',
		meta: {
			title: 'menu.countries'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Countries')
	},
	{
		path: '/cities/:page?/:id?',
		name: 'Cities',
		icon: 'city',
		meta: {
			title: 'menu.cities'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Cities')
	},
	{
		path: '/dealers/:page?/:id?',
		name: 'Dealers',
		icon: 'handshake',
		meta: {
			title: 'menu.dealers'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Dealers')
	},
	{
		path: '/vehicles/:page?/:id?',
		name: 'Vehicles',
		icon: 'car',
		meta: {
			title: 'menu.vehicles'
		},
		beforeEnter: auth,
		component: () => import('@/pages/Vehicles')
	},
	// REMOVER DAQUI PRA BAIXO
	{
		path: '/aftersales/main-commercial/kpis',
		name: 'aftersales-kpis',
		icon: 'dashboard',
		meta: {
			title: 'menu.kpis'
		},
		beforeEnter: auth,
		component: () => import('@/pages/aftersales/KPIs')
	},
	{
		path: '/aftersales/main-commercial/staff-meeting',
		name: 'aftersales-main-staff',
		icon: 'dashboard',
		meta: {
			title: 'menu.staff_meeting'
		},
		beforeEnter: auth,
		component: () => import('@/pages/aftersales/StaffMeeting')
	},
	{
		path: '/aftersales/technical-services/overview',
		name: 'aftersales-technical-overview',
		icon: 'dashboard',
		meta: {
			title: 'menu.overview'
		},
		beforeEnter: auth,
		component: () => import('@/pages/aftersales/Overview')
	},
	{
		path: '/aftersales/technical-services/payments',
		name: 'aftersales-technical-payments',
		icon: 'dashboard',
		meta: {
			title: 'menu.payments'
		},
		beforeEnter: auth,
		component: () => import('@/pages/aftersales/Payments')
	}
	/* auto-gerado */
];
